module.exports = __webpack_public_path__ + "img/type_FAIRY.b5eb1904.png";